<template>
    <div>
        <!-- Start Page Title -->
        <div class="page-title-area">
            <div class="d-table">
                <div class="d-table-cell">
                    <div class="container">
                        <h2>Pricing</h2>
                    </div>
                </div>
			</div>
			
			<div class="shape1"><img src="../../../assets/img/shape1.png" alt="shape"></div>
			<div class="shape2 rotateme"><img src="../../../assets/img/shape2.svg" alt="shape"></div>
			<div class="shape3"><img src="../../../assets/img/shape3.svg" alt="shape"></div>
			<div class="shape4"><img src="../../../assets/img/shape4.svg" alt="shape"></div>
			<div class="shape5"><img src="../../../assets/img/shape5.png" alt="shape"></div>
			<div class="shape6 rotateme"><img src="../../../assets/img/shape4.svg" alt="shape"></div>
			<div class="shape7"><img src="../../../assets/img/shape4.svg" alt="shape"></div>
			<div class="shape8 rotateme"><img src="../../../assets/img/shape2.svg" alt="shape"></div>
        </div>
        <!-- End Page Title -->

        <!-- Start Pricing Area -->
		<section class="pricing-area ptb-80 bg-f9f6f6">
			<div class="container">
				<div class="section-title">
					<h2>Pricing Plans</h2>
					<div class="bar"></div>
					<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
				</div>

				<div class="row">
                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="pricing-table">
                            <div class="pricing-header">
                                <h3>Basic Plan</h3>
                            </div>
                            
                            <div class="price">
                                <span><sup>$</sup>15.00 <span>/Mon</span></span>
                            </div>
                            
                            <div class="pricing-features">
                                <ul>
                                    <li class="active">5 GB Bandwidth</li>
                                    <li class="active">Highest Speed</li>
                                    <li class="active">1 GB Storage</li>
                                    <li class="active">Unlimited Website</li>
                                    <li class="active">Unlimited Users</li>
                                    <li class="active">24x7 Great Support</li>
                                    <li>Data Security and Backups</li>
                                    <li>Monthly Reports and Analytics</li>
                                </ul>
                            </div>
                            
                            <div class="pricing-footer">
                                <a href="#" class="btn btn-primary">Select Plan</a>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="pricing-table active-plan">
                            <div class="pricing-header">
                                <h3>Advanced Plan</h3>
                            </div>
                            
                            <div class="price">
                                <span><sup>$</sup>35.00 <span>/Mon</span></span>
                            </div>
                            
                            <div class="pricing-features">
                                <ul>
                                    <li class="active">10 GB Bandwidth</li>
                                    <li class="active">Highest Speed</li>
                                    <li class="active">3 GB Storage</li>
                                    <li class="active">Unlimited Website</li>
                                    <li class="active">Unlimited Users</li>
                                    <li class="active">24x7 Great Support</li>
                                    <li class="active">Data Security and Backups</li>
                                    <li>Monthly Reports and Analytics</li>
                                </ul>
                            </div>
                            
                            <div class="pricing-footer">
                                <a href="#" class="btn btn-primary">Select Plan</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                        <div class="pricing-table">
                            <div class="pricing-header">
                                <h3>Expert Plan</h3>
                            </div>
                            
                            <div class="price">
                                <span><sup>$</sup>65.00 <span>/Mon</span></span>
                            </div>
                            
                            <div class="pricing-features">
                                <ul>
                                    <li class="active">15 GB Bandwidth</li>
                                    <li class="active">Highest Speed</li>
                                    <li class="active">5 GB Storage</li>
                                    <li class="active">Unlimited Website</li>
                                    <li class="active">Unlimited Users</li>
                                    <li class="active">24x7 Great Support</li>
                                    <li class="active">Data Security and Backups</li>
                                    <li class="active">Monthly Reports and Analytics</li>
                                </ul>
                            </div>
                            
                            <div class="pricing-footer">
                                <a href="#" class="btn btn-primary">Select Plan</a>
                            </div>
                        </div>
                    </div>
				</div>
			</div>

			<div class="shape8 rotateme"><img src="../../../assets/img/shape2.svg" alt="shape"></div>
			<div class="shape2 rotateme"><img src="../../../assets/img/shape2.svg" alt="shape"></div>
			<div class="shape7"><img src="../../../assets/img/shape4.svg" alt="shape"></div>
			<div class="shape4"><img src="../../../assets/img/shape4.svg" alt="shape"></div>
		</section>
		<!-- End Pricing Area -->

        <!-- Start Pricing Two Area -->
        <section class="pricing-area ptb-80">
            <div class="container">
                <div class="section-title">
                    <h2>Our Pricing Plan</h2>
                    <div class="bar"></div>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                </div>
                
                <div class="tab pricing-tab bg-color">
                    <b-card no-body>
                        <b-tabs 
                            content-class="mt-3" 
                            align="center"
                            active-nav-item-class="current"
                        >
                            <b-tab title="Monthly Plan" active>
                                <div class="tabs_item">
                                    <div class="row">
                                        <div class="col-lg-4 col-md-6 col-sm-6">
                                            <div class="pricing-box">
                                                <div class="pricing-header">
                                                    <h3>Free</h3>
                                                    <p>Get your business up <br>and running</p>
                                                </div>

                                                <div class="price">
                                                    $0 <span>/m</span>
                                                </div>

                                                <div class="buy-btn">
                                                    <a href="#" class="btn btn-primary">Get Started Free</a>
                                                </div>

                                                <ul class="pricing-features">
                                                    <li><feather type='check'></feather> Drag & Drop Builder</li>
                                                    <li><feather type='check'></feather> Lead Generation & Sales</li>
                                                    <li><feather type='check'></feather> Boot & Digital Assistants</li>
                                                    <li><feather type='check'></feather> Customer Service</li>
                                                    <li><feather type='check'></feather> Up to 1000 Subscribers</li>
                                                    <li><feather type='check'></feather> Unlimited Broadcasts</li>
                                                    <li><feather type='check'></feather> Landing Pages & Web Widgets</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="col-lg-4 col-md-6 col-sm-6">
                                            <div class="pricing-box">
                                                <div class="pricing-header">
                                                    <h3>Pro</h3>
                                                    <p>Get your business up <br>and running</p>
                                                </div>

                                                <div class="price">
                                                    $149 <span>/m</span>
                                                </div>

                                                <div class="buy-btn">
                                                    <a href="#" class="btn btn-primary">Start 3 Days Free Trial</a>
                                                </div>

                                                <ul class="pricing-features">
                                                    <li><feather type='check'></feather> Drag & Drop Builder</li>
                                                    <li><feather type='check'></feather> Lead Generation & Sales</li>
                                                    <li><feather type='check'></feather> Boot & Digital Assistants</li>
                                                    <li><feather type='check'></feather> Customer Service</li>
                                                    <li><feather type='check'></feather> Up to 3300 Subscribers</li>
                                                    <li><feather type='check'></feather> Unlimited Broadcasts</li>
                                                    <li><feather type='check'></feather> Landing Pages & Web Widgets</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                                            <div class="pricing-box">
                                                <div class="pricing-header">
                                                    <h3>Premium</h3>
                                                    <p>Get your business up <br>and running</p>
                                                </div>

                                                <div class="price">
                                                    $179 <span>/m</span>
                                                </div>

                                                <div class="buy-btn">
                                                    <a href="#" class="btn btn-primary">Start 6 Days Free Trial</a>
                                                </div>

                                                <ul class="pricing-features">
                                                    <li><feather type='check'></feather> Drag & Drop Builder</li>
                                                    <li><feather type='check'></feather> Lead Generation & Sales</li>
                                                    <li><feather type='check'></feather> Boot & Digital Assistants</li>
                                                    <li><feather type='check'></feather> Customer Service</li>
                                                    <li><feather type='check'></feather> Up to 10000 Subscribers</li>
                                                    <li><feather type='check'></feather> Unlimited Broadcasts</li>
                                                    <li><feather type='check'></feather> Landing Pages & Web Widgets</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab title="Yearly Plan" lazy> 
                                <div class="tabs_item">
                                    <div class="row">
                                        <div class="col-lg-4 col-md-6 col-sm-6">
                                            <div class="pricing-box">
                                                <div class="pricing-header">
                                                    <h3>Free</h3>
                                                    <p>Get your business up <br>and running</p>
                                                </div>

                                                <div class="price">
                                                    $0 <span>/y</span>
                                                </div>

                                                <div class="buy-btn">
                                                    <a href="#" class="btn btn-primary">Get Started Free</a>
                                                </div>

                                                <ul class="pricing-features">
                                                    <li><feather type='check'></feather> Drag & Drop Builder</li>
                                                    <li><feather type='check'></feather> Lead Generation & Sales</li>
                                                    <li><feather type='check'></feather> Boot & Digital Assistants</li>
                                                    <li><feather type='check'></feather> Customer Service</li>
                                                    <li><feather type='check'></feather> Up to 1000 Subscribers</li>
                                                    <li><feather type='check'></feather> Unlimited Broadcasts</li>
                                                    <li><feather type='check'></feather> Landing Pages & Web Widgets</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="col-lg-4 col-md-6 col-sm-6">
                                            <div class="pricing-box">
                                                <div class="pricing-header">
                                                    <h3>Pro</h3>
                                                    <p>Get your business up <br>and running</p>
                                                </div>

                                                <div class="price">
                                                    $249 <span>/y</span>
                                                </div>

                                                <div class="buy-btn">
                                                    <a href="#" class="btn btn-primary">Start 3 Days Free Trial</a>
                                                </div>

                                                <ul class="pricing-features">
                                                    <li><feather type='check'></feather> Drag & Drop Builder</li>
                                                    <li><feather type='check'></feather> Lead Generation & Sales</li>
                                                    <li><feather type='check'></feather> Boot & Digital Assistants</li>
                                                    <li><feather type='check'></feather> Customer Service</li>
                                                    <li><feather type='check'></feather> Up to 3300 Subscribers</li>
                                                    <li><feather type='check'></feather> Unlimited Broadcasts</li>
                                                    <li><feather type='check'></feather> Landing Pages & Web Widgets</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                                            <div class="pricing-box">
                                                <div class="pricing-header">
                                                    <h3>Premium</h3>
                                                    <p>Get your business up <br>and running</p>
                                                </div>

                                                <div class="price">
                                                    $279 <span>/y</span>
                                                </div>

                                                <div class="buy-btn">
                                                    <a href="#" class="btn btn-primary">Start 6 Days Free Trial</a>
                                                </div>

                                                <ul class="pricing-features">
                                                    <li><feather type='check'></feather> Drag & Drop Builder</li>
                                                    <li><feather type='check'></feather> Lead Generation & Sales</li>
                                                    <li><feather type='check'></feather> Boot & Digital Assistants</li>
                                                    <li><feather type='check'></feather> Customer Service</li>
                                                    <li><feather type='check'></feather> Up to 10000 Subscribers</li>
                                                    <li><feather type='check'></feather> Unlimited Broadcasts</li>
                                                    <li><feather type='check'></feather> Landing Pages & Web Widgets</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </b-card>
                </div>
            </div>

            <div class="shape2 rotateme"><img src="../../../assets/img/shape2.svg" alt="shape"></div>
            <div class="shape3"><img src="../../../assets/img/shape3.svg" alt="shape"></div>
            <div class="shape4"><img src="../../../assets/img/shape4.svg" alt="shape"></div>
            <div class="shape6 rotateme"><img src="../../../assets/img/shape4.svg" alt="shape"></div>
            <div class="shape7"><img src="../../../assets/img/shape4.svg" alt="shape"></div>
            <div class="shape8 rotateme"><img src="../../../assets/img/shape2.svg" alt="shape"></div>
        </section>
        <!-- End Pricing Two Area -->
    </div>
</template>

<script>
export default {
    name: 'Pricing'
}
</script>